import "./event_card.scss";
